document.addEventListener("DOMContentLoaded", function () {
  const upsellAddToCartButtons = document.querySelectorAll(".upsell_add_toCart")

  function getVariantPriceById(variantId) {
    var request = new XMLHttpRequest()
    var url = "/variants/" + variantId + ".js"
    var price = null

    try {
      request.open("GET", url, false) // `false` makes the request synchronous
      request.send()

      if (request.status === 200) {
        var variant = JSON.parse(request.responseText)
        price = variant.price / 100 // Shopify prices are in cents
      } else {
        console.error("Error fetching variant data:", request.statusText)
      }
    } catch (error) {
      console.error("Request failed:", error)
    }
    return price * 100
  }

  if (upsellAddToCartButtons.length > 0) {
    let indivisualUpsell,
      indivisualUpsellId = ""
    upsellAddToCartButtons.forEach((button) => {
      button.addEventListener("click", function (event) {
        event.preventDefault()
        const productElements = document.querySelectorAll(
          ".upsell_metafield_product .select_metafield_product input:checked",
        )

        productElements.forEach((element) => {
          indivisualUpsell = element.getAttribute("data-indivisual")
          indivisualUpsellId = element.getAttribute("data-variant-id")
        })

        const mainProductIdElement = document.querySelector(
          '.product__info-wrapper .product-form [type="hidden"].product-variant-id',
        )
        const mainProductPriceElement = document.querySelector(
          '.product__info-wrapper .product-form [type="hidden"].product-org-price',
        )

        // if (!mainProductIdElement) {
        //   console.error('Main product ID element not found');
        //   return;
        // }

        const variantIds = Array.from(productElements).map(
          (el) => el.dataset.variantId,
        )

        let mainProductId,
          defaultId = ""

        mainProductId = mainProductIdElement.value

        if (!indivisualUpsell) {
          defaultId = document.querySelector(
            '.product__info-wrapper .product-form [type="hidden"].product-variant-id',
          ).value
        }

        if (defaultId != "") {
          variantIds.push(defaultId)
        }

        if (variantIds == "") {
          variantIds.push(mainProductId)
        }

        const variantIdsNew = variantIds.filter((item) => item)

        const cart = document.querySelector("cart-drawer") // Reference to the cart drawer element
        //  return false;
        var final_price_new = 0
        const addProductToCart = (variantId) => {
          let prodPriceCart = getVariantPriceById(variantId)
          const formData = new FormData()
          formData.append("id", variantId)
          formData.append("properties[_orgPrice]", prodPriceCart)
          formData.append("quantity", 1) // Adjust the quantity as needed
          formData.append(
            "sections",
            cart.getSectionsToRender().map((section) => section.id),
          )
          const config = {
            method: "POST",
            body: formData,
            headers: {
              Accept: "application/json",
            },
          }

          return fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              final_price_new += parseFloat(response.line_price)

              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: variantId,
                  errors: response.errors || response.description,
                  message: response.message,
                })
                handleError(response.description)
                return null // Return null to indicate failure
              } else {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: variantId,
                  cartData: response,
                })
                return response // Return response data for success
              }
            })
            .catch((error) => {
              console.error(error)
              return null // Return null to indicate failure
            })
            .finally(() => {
              // console.log("update cart---", final_price_new)
              // document.querySelectorAll('.show-sub-total span:nth-child(2)').html = final_price_new;
              if (cart && cart.classList.contains("is-empty"))
                cart.classList.remove("is-empty")
            })
        }

        // Function to handle the error message
        const handleError = (description) => {
          console.error(description)
        }

        // Disable the button and show loading spinner
        button.setAttribute("aria-disabled", true)
        button.classList.add("loading")

        // Add all products to the cart sequentially
        const addAllProducts = async () => {
          const responses = []
          for (const variantId of variantIdsNew) {
            try {
              const response = await addProductToCart(variantId)
              if (response) {
                responses.push(response)
              }
            } catch (error) {
              console.error(error)
              // Handle error if needed
            }
          }

          const updateCartCount = async () => {
            try {
              const response = await fetch(location.href)
              const text = await response.text()
              const tempDiv = document.createElement("div")
              tempDiv.innerHTML = text
              const newCartCount = tempDiv.querySelector(
                ".header__icons .header__icon.header__icon--cart .cart-count-bubble span",
              ).innerHTML
              document.querySelector(".cart-count-bubble").innerHTML =
                newCartCount
            } catch (error) {
              console.error("Error fetching cart count:", error)
            }
          }

          if (responses.length > 0 && cart) {
            responses.forEach((el) => {
              cart.renderContents(el)
            })
            // document
            //   .querySelectorAll(".show-sub-total span:nth-child(2)")
            //   .setAttribute("id", "itemAmount")
            // cart.renderContents(responses[0]) // Assuming responses are consistent in structure, just using the first one for updating cart
            cart.open() // Open the cart drawer
            updateCartCount()
          }

          button.classList.remove("loading")
          button.removeAttribute("aria-disabled")
        }

        addAllProducts()
      })
    })
  }

  document.querySelectorAll(".upsell_produt input").forEach(function (input) {
    input.addEventListener("change", function () {
      dataLayer.push({
        event: "variant_selector",
        selection: this.dataset.variantName,
        page_location: window.location.href,
      })
      if (theme_custom.variantChange) theme_custom.variantChange()
    })
  })
  document.querySelectorAll("variant-selects input").forEach(function (input) {
    input.addEventListener("change", function () {
      dataLayer.push({
        event: "variant_selector",
        selection: this.dataset.variantName,
        page_location: window.location.href,
      })
      if (theme_custom.variantChange) theme_custom.variantChange()
    })
  })
})
